import './app.js'
import { loadScript } from './helpers.js'

const ratio = 1.88
const mapDiv = document.getElementById( 'map' )

/**
 * Resize map
 */
window.addEventListener( 'resize', () => {
  const { clientWidth: width } = mapDiv
  const { innerWidth, innerHeight } = window

  mapDiv.style.height = Math.round( width / ( innerWidth > innerHeight ? ratio : 1 ) ) + 'px'
})
window.dispatchEvent( new Event( 'resize' ) )

//delayed load map
setTimeout( () => {
  loadScript( `https://maps.googleapis.com/maps/api/js?v=3&key=${process.env.MIX_G_MAP_KEY}`, {
    callback : () => {
      loadScript( '/js/stores-map.js' )
    }
  })
}, process.env.MIX_LIB_3RD_DELAY )

